import styled from "@mui/material/styles/styled";

export const StyledLink = styled("a")(() => ({
  textDecoration: "none",
  color: "white",
}));
